import Sortable from 'sortablejs'

export default {
  mounted() {
    const handleSelector = this.el.dataset.handle || '.drag-handle'

    let sorter = new Sortable(this.el, {
      // animation: 150,
      // delay: 100,
      handle: handleSelector,
      fallbackTolerance: 10,
      direction: 'vertical',
      animation: 300,
      easing: 'cubic-bezier(1, 0, 0, 1)',
      // draggable: '.cursor-pointer',
      // dragClass: 'drag-item',
      // ghostClass: 'drag-ghost',
      // forceFallback: true,
      // preventOnFilter: true,
      // filter: '.no-drag',
      onEnd: (e) => {
        let params = { old: e.oldIndex, new: e.newIndex, ...e.item.dataset }
        this.pushEventTo(this.el, 'change_order', params)
      },
    })
  },
}
